export default "__VITE_ASSET__bf3d1c0a__"